<template>
  <div>
    <form
      class="form form-horizontal"
      role="form"
      @submit.prevent="saveRequest"
      id="ma-form"
      name="myForm"
      novalidate
    >
      <modal :width="width">
        <div slot="header">
          <button type="button" class="close" @click="CloseModal">
            &times;
          </button>
          <h2 class="modal-title">
            {{ RequestId == null ? "Add Request" : "Edit Request" }}
          </h2>
        </div>
        <div slot="body">
          <div v-if="success_message != '' && success_message != null">
            <div class="alert alert-success text-center">
              <strong>{{ success_message }}</strong>
            </div>
          </div>
          <div
            v-if="request_error_message != null && request_error_message != ''"
          >
            <div class="alert alert-danger text-center">
              <strong>{{ request_error_message }}</strong>
            </div>
          </div>
          <div v-if="errorMessage != null && errorMessage != ''">
            <div class="alert alert-danger text-center">
              <strong>{{ errorMessage }}</strong>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Department
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="DeptId"
                v-model="DeptId"
                data-vv-as="Department Type"
                data-vv-validate-on="blur"
                v-validate="'required'"
                @change="ChangeReference"
                :class="{
                  'input-validation-error':
                    (DeptIdFlags.invalid && !DeptIdFlags.pristine) ||
                    errors.has('DeptId'),
                }"
              >
                <option
                  v-for="(option, index) in Departments"
                  :key="'dept' + index"
                  :value="option.Id"
                >
                  {{ option.Name }}
                </option>
              </select>
              <span class="text-danger">{{ errors.first("DeptId") }}</span>
            </div>
            <div class="col-xs-4">
              <label>Fajr Reference No</label>

              <input
                type="text"
                class="form-control"
                name="FajrReferenceNo"
                placeholder="Reference ID"
                v-model="FajrReferenceNo"
                readonly
              />
            </div>

            <div class="col-xs-4">
              <label>
                Transaction Date
                <span class="text-danger">*</span>
              </label>
              <date-pick
                v-model="ApplicationDate"
                :format="'DD-MM-YYYY'"
                :inputAttributes="{ class: ApplicationDateClass }"
                :isDateDisabled="isFutureDate"
                @input="CheckApplicationDateValid"
              ></date-pick>
              <span class="text-danger">{{
                errors.first("ApplicationDate")
              }}</span>
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4" v-if="DeptId == 3 || DeptId == 4">
              <label>
                Transaction Type
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="TransactionType"
                v-model="TransactionTypeId"
                data-vv-validate-on="blur"
                v-validate="'required'"
                :class="{
                  'input-validation-error':
                    (TransactionTypeFlags.invalid &&
                      !TransactionTypeFlags.pristine) ||
                    errors.has('TransactionType'),
                }"
              >
                <option
                  v-for="(option, index) in TRANSACTIONTYPE"
                  :key="'trans' + index"
                  :value="option.Id"
                >
                  {{ option.Name }}
                </option>
              </select>
              <span class="text-danger">{{
                errors.first("TransactionType")
              }}</span>
            </div>

            <div class="col-xs-4">
              <label>
                Currency
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="Currency"
                v-model="CurrencyId"
                data-vv-validate-on="blur"
                v-validate="'required'"
                :class="{
                  'input-validation-error':
                    (CurrencyFlags.invalid && !CurrencyFlags.pristine) ||
                    errors.has('Currency'),
                }"
              >
                <option
                  v-for="(option, index) in Currency"
                  :key="'currency' + index"
                  :value="option.Id"
                >
                  {{ option.ShortName }}
                </option>
              </select>
              <span class="text-danger">{{ errors.first("Currency") }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Commodity
                <span class="text-danger">*</span>
              </label>
              <select
                class="form-control input-sm"
                name="Commodityid"
                v-model="Commodity"
                data-vv-as="Commodity"
                data-vv-validate-on="blur"
                v-validate="'required'"
                :class="{
                  'input-validation-error':
                    (CommodityidFlags.invalid && !CommodityidFlags.pristine) ||
                    errors.has('Commodityid'),
                }"
              >
                <option
                  v-for="(option, index) in CommoditiesOfBank"
                  :key="'com' + index"
                  :value="option.Id"
                >
                  {{ option.Name }}
                </option>
              </select>
              <span class="text-danger">{{ errors.first("Commodityid") }}</span>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-8" v-if="TransactionTypeId == 2">
              <label>
                Client Name
                <span class="text-danger">*</span>
              </label>
              <suggestions
                v-model="ClientName"
                :options="options"
                :onInputChange="Autocomplete"
              />
              <span class="text-danger">{{ errors.first("ClientName") }}</span>
            </div>
            <div class="col-xs-4">
              <label> Exchange Rate </label>
              <input
                type="text"
                class="form-control"
                name="ExchageRate"
                placeholder="Exchange Rate"
                autocomplete="off"
                v-model="ExchangeRate"
                disabled
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Amount
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Amount"
                placeholder="Amount"
                autocomplete="off"
                v-model="Amount"
                data-vv-validate-on="blur"
                v-validate="'required|decimal'"
                :class="{
                  'input-validation-error':
                    (AmountFlags.invalid && !AmountFlags.pristine) ||
                    errors.has('Amount'),
                }"
              />
              <span class="text-danger">{{ errors.first("Amount") }}</span>
            </div>
            <div class="col-xs-4">
              <label>Commodity Price</label>
              <input
                type="text"
                class="form-control"
                v-model="UnitPrice"
                name="UnitPrice"
                placeholder="Unit Price"
                readonly
              />
              <span class="text-danger">{{ errors.first("UnitPrice") }}</span>
            </div>
            <div class="col-xs-4">
              <label>
                Quantity
                <span class="text-danger">*</span>
              </label>

              <input
                type="text"
                class="form-control"
                name="Quantity"
                placeholder="Quantity"
                v-model="Quantity"
                readonly
              />
            </div>
          </div>
          <div class="form-group">
            <div class="col-xs-4">
              <label>
                Value Date
                <span class="text-danger">*</span>
              </label>
              <date-pick
                v-model="ValueDate"
                :format="'DD-MM-YYYY'"
                :inputAttributes="{ class: ValueDateClass }"
                @input="ValueDateValid"
              ></date-pick>
              <span class="text-danger">{{ errors.first("ValueDate") }}</span>
            </div>
            <div class="col-xs-4">
              <label
                >Maturity Date
                <span class="text-danger">*</span>
              </label>
              <date-pick
                v-model="MaturityDate"
                :format="'DD-MM-YYYY'"
                :inputAttributes="{ class: 'form-control' }"
              ></date-pick>
              <span class="text-danger">{{
                errors.first("MaturityDate")
              }}</span>
            </div>

            <div class="col-xs-4">
              <label>Your Reference</label>
              <input
                type="text"
                class="form-control"
                v-model="YourRefrence"
                name="BankReference"
                data-vv-as="Your Reference"
                v-validate="'Reference|max:250'"
                autocomplete="off"
                maxlength="250"
                :class="{
                  'input-validation-error':
                    (BankReferenceFlags.invalid &&
                      !BankReferenceFlags.pristine) ||
                    errors.has('BankReference'),
                }"
              />
              <span class="text-danger">{{
                errors.first("BankReference")
              }}</span>
            </div>
          </div>

          <div class="form-group">
            <div class="col-xs-8">
              <label>Comments</label>
              <input
                type="text"
                class="form-control"
                v-model="Comments"
                name="PurchaseComment"
                data-vv-as="Comment"
                maxlength="500"
                autocomplete="off"
                v-validate="'valid_FirstChar|max:250'"
                :class="{
                  'input-validation-error':
                    (PurchaseCommentFlags.invalid &&
                      !PurchaseCommentFlags.pristine) ||
                    errors.has('PurchaseComment'),
                }"
              />
              <span class="text-danger">{{
                errors.first("PurchaseComment")
              }}</span>
            </div>
          </div>
        </div>
        <div slot="footer">
          <span class="pull-left text-danger">*Mandatory fields</span>
          <loading v-if="loading"></loading>
          <input
            type="submit"
            class="btn btn-primary"
            value="Request"
            v-if="
              (RoleId == 4 || RoleId == 5) && (Sell == null || Sell == false)
            "
          />
          <button
            type="button"
            class="btn btn-danger"
            v-if="RequestId && RequestId != 0 && (RoleId == 4 || RoleId == 5)"
            @click="OpenConfirmation"
          >
            Cancel Transaction
          </button>
          <button type="button" class="btn btn-warning" @click="CloseModal">
            Cancel
          </button>
        </div>
      </modal>
    </form>
    <modal v-if="DeleteConfirm">
      <div slot="header">
        <h3>Delete Transaction</h3>
      </div>
      <div slot="body">
        <div>
          <div v-if="CONFIRMERROR != null && CONFIRMERROR != ''">
            <div class="alert alert-danger text-center">
              <strong>{{ CONFIRMERROR }}</strong>
            </div>
          </div>
          <input
            type="text"
            class="form-control"
            v-model="CancelComments"
            autocomplete="off"
            name="CancelComments"
            v-validate="'valid_FirstChar|max:250'"
            placeholder="Cancel Comments"
            data-vv-as="Cancel Comments"
            maxlength="250"
            data-vv-validate-on="blur"
          />
          <span class="text-danger">{{ errors.first("CancelComments") }}</span>
        </div>
      </div>
      <div slot="footer">
        <loading v-if="CONFIRMLOADING"></loading>
        <button class="btn btn-danger" @click="Delete">Delete</button>
        <button class="btn btn-warning" @click="GoBack">Back</button>
      </div>
    </modal>
  </div>
</template>

<script>
import * as ACTIONS from "../../store/actions";
import { mapGetters, mapState } from "vuex";
import { mapFields } from "vee-validate";
import suggestions from "v-suggestions";
import DatePick from "vue-date-pick";
//import { ErrorBag } from "vee-validate";
//var errorbag = new ErrorBag();
//import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
export default {
  data() {
    return {
      width: 800,
      success_message: null,
      DeleteConfirm: false,
      request_error_message: null,
      ClientName: "",
      DeptId: null,
      ApplicationDate: new Date(),
      CurrencyId: 3,
      Commodity: 6,
      ExchageRate: null,
      Amount: null,
      Quantity: 0.0,
      ValueDate: null,
      MaturityDate: null,
      UnitPrice: 0,
      YourRefrence: null,
      Comments: null,
      FajrReferenceNo: "",
      RefNo: "",
      FajrReferenceId: null,
      options: {
        inputClass: "form-control",
        placeholder: "Client Name",
        maxlength: 250,
      },
      TransactionTypeId: 1,
      SellAccepted: null,
      Sell: null,
      CancelComments: null,
      ApplicationDateClass: "form-control",
      ValueDateClass: "form-control",

      ExchangeRate: 0.0,
      ClickDisabled: false,
      // countries: countries
    };
  },
  components: {
    suggestions,
    DatePick,
  },
  props: { RequestId: Number },
  methods: {
    isFutureDate(date) {
      const currentDate = new Date();
      return date > currentDate;
    },
    OpenConfirmation() {
      this.$store.commit(ACTIONS.CANCEL_TRANSACTION_SUCCESS);
      this.DeleteConfirm = true;
    },
    GoBack() {
      this.CancelComments = null;
      this.$validator.errors.remove("CancelComments");
      var vm = this;
      this.$store.commit(ACTIONS.CANCEL_TRANSACTION_SUCCESS);
      setTimeout(function () {
        vm.DeleteConfirm = false;
      }, 100);
    },
    IsValidate(Name, _error) {
      if (this[Name] == "" || this[Name] == null) {
        this[Name + "Class"] = "form-control input-validation-error";
        this.$validator.errors.add({
          field: Name,
          msg: _error,
        });
      } else {
        this[Name + "Class"] = "form-control";
        this.$validator.errors.remove(Name);
      }
    },
    ValueDateValid() {
      this.IsValidate("ValueDate", "Please select Value Date");
      if (
        this.ValueDate == "" ||
        (this.ValueDate != null && this.ValueDate < this.ApplicationDate)
      ) {
        this.ApplicationDate = this.ValueDate;
      }
      var query = "?dt=" + this.GetCorrectFormat(this.ApplicationDate);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.BUY_REQUEST_COMMODITYPRICES_GET, query)
        .then((res) => {
          var { data } = res;
          vm.CalCulate();
          if (data && data.StatusCode != 200) {
            console.log(data.StatusMessage);
          }
        })
        .catch((err) => {
          this.request_error_message = "Failed  to fetch Commodity prices.";
          console.log(err);
          setTimeout(function () {
            vm.request_error_message = null;
          }, 3000);
        });
    },
    CheckApplicationDateValid() {
      this.IsValidate("ApplicationDate", "Please select Application Date");
      if (this.ApplicationDate == "" || this.ApplicationDate != null) {
        this.ValueDate = this.ApplicationDate;
      }
    },
    ChangeReference() {
      this.ClientName = "";
      this.TransactionTypeId = null;
      for (var i = 0; i < this.Departments.length; i++) {
        if (this.DeptId == this.Departments[i].Id) {
          this.FajrReferenceNo = this.Departments[i].RefNo;
          break;
        }
      }
    },
    Delete() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$validator.errors.remove("CancelComments");
          var params = new URLSearchParams();
          params.append("RequestId", this.RequestId);
          if (this.CancelComments != null && this.CancelComments != "") {
            params.append("CancelComments", this.CancelComments);
          }
          // if (this.Commodity != null && this.Commodity != 0) {
          //   params.append("Commodityid", this.Commodity);
          // }
          var vm = this;
          this.$store
            .dispatch(ACTIONS.CANCEL_TRANSACTION, params)
            .then((res) => {
              var { data } = res;
              if (data && data.StatusCode == 200) {
                vm.DeleteConfirm = false;
                vm.CancelComments = "";
                vm.success_message = "Transaction Deleted";
                setTimeout(function () {
                  vm.success_message = null;
                  vm.CloseModal();
                }, 1500);
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    vm.$validator.errors.add({
                      field: prop,
                      msg: ResponseData[prop],
                    });
                  }
                }
              } else if (
                data &&
                (data.StatusCode == 500 ||
                  data.StatusCode == 403 ||
                  data.StatusCode == 2 ||
                  data.StatusCode == 429 ||
                  data.StatusCode == 1 ||
                  data.StatusCode == 406 ||
                  data.StatusCode == 0)
              ) {
              } else {
                vm.DeleteConfirm = false;
                vm.CancelComments = "";
                console.log(res);
              }
            })
            .catch((err) => {
              vm.DeleteConfirm = false;
              vm.CancelComments = "";
              console.log(err);
            });
        }
      });
    },
    saveRequest() {
      if (this.ClickDisabled) {
        return;
      }
      var vm = this;
      var IsValid = true;
      if (this.ValueDate == null || this.ValueDate == "") {
        IsValid = false;
        this.$validator.errors.add({
          field: "ValueDate",
          msg: "The Value Date field is required.",
        });
      }
      if (this.MaturityDate == null || this.MaturityDate == "") {
        IsValid = false;
        this.$validator.errors.add({
          field: "MaturityDate",
          msg: "The Maturity Date field is required.",
        });
      }
      if (
        this.TransactionTypeId == 2 &&
        (this.ClientName == null || this.ClientName == "")
      ) {
        IsValid = false;
        this.$validator.errors.add({
          field: "ClientName",
          msg: "The Client Name field is required.",
        });
      }
      if (!IsValid) {
        this.$validator.validateAll();
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          vm.ClickDisabled = true;
          var params = new URLSearchParams();
          params.append("RequestId", vm.RequestId == null ? 0 : vm.RequestId);
          params.append("RefNo", vm.FajrReferenceNo);
          console.log(vm.DeptId);
          params.append("DeptId", vm.DeptId == null ? 0 : vm.DeptId);

          params.append(
            "TransactionType",
            vm.TransactionTypeId == null ? 0 : vm.TransactionTypeId
          );
          params.append(
            "ClientName",
            vm.ClientName == null ? "" : vm.ClientName
          );
          params.append(
            "ApplicationDate",
            vm.GetCorrectFormat(vm.ApplicationDate)
          );
          params.append("Currency", vm.CurrencyId == null ? 0 : vm.CurrencyId);
          params.append("Commodityid", vm.Commodity == null ? 0 : vm.Commodity);
          params.append("Amount", vm.Amount == null ? 0 : vm.Amount);
          params.append("Quantity", vm.Quantity == null ? 0 : vm.Quantity);
          params.append("ValueDate", vm.GetCorrectFormat(vm.ValueDate));
          if (vm.MaturityDate) {
            params.append("MaturityDate", vm.GetCorrectFormat(vm.MaturityDate));
          }
          //params.append("ValueDate", vm.ValueDate);
          params.append(
            "BankReference",
            vm.YourRefrence == null ? "" : vm.YourRefrence
          );
          params.append(
            "PurchaseComment",
            vm.Comments == null ? "" : vm.Comments
          );

          this.$store
            .dispatch(ACTIONS.BUY_REQUEST_SAVE, params)
            .then((res) => {
              vm.ClickDisabled = false;
              var { data } = res;
              if (data && data.StatusCode == 200) {
                if (vm.RequestId == null || vm.RequestId == 0) {
                  vm.success_message = "Transaction Added Successfully";
                } else {
                  vm.success_message = "Transaction modified Successfully";
                }
                setTimeout(function () {
                  vm.success_message = null;
                  vm.CloseModal();
                }, 1500);
              } else if (data && data.StatusCode == 422) {
                vm.ChangeReference();
              } else if (data && data.StatusCode == 450) {
                var { ResponseData } = data;
                if (ResponseData) {
                  for (var prop in ResponseData) {
                    var errorFilds = {
                      DeptId: "Department",
                      TransactionType: "Transaction Type",
                      Commodityid: "Commodity",
                      ValueDate: "Value Date",
                      MaturityDate: "Maturity Date",
                      ApplicationDate: "Application Date",
                    };
                    var msg = null;
                    for (var key in errorFilds) {
                      if (key == prop) {
                        msg = ResponseData[prop].replace(key, errorFilds[key]);
                        msg = msg.replace("property", "field");
                      }
                    }

                    vm.$validator.errors.add({
                      field: prop,
                      msg: msg == null ? ResponseData[prop] : msg,
                    });
                  }
                }
              } else {
                Console.log(res);
              }
            })
            .catch((err) => {
              vm.ClickDisabled = false;
              console.log(err);
            });
        } else {
          vm.ClickDisabled = false;
          vm.request_error_message = "Please  provide Correct details";
          setTimeout(function () {
            vm.request_error_message = null;
          }, 1500);
        }
      });
    },
    Autocomplete(query) {
      this.ClientName = query;
      this.$validator.errors.remove("ClientName");
      if (query == null || query.trim().length === 0) {
        this.$validator.errors.add({
          field: "ClientName",
          msg: "The Client Name field is required.",
        });
        return null;
      }
      var re = this.ClientName.charAt(0);
      if (re == "@" || re == "+" || re == "-" || re == "=") {
        this.$validator.errors.add({
          field: "ClientName",
          msg: "First character shuold not be '@','-',+','='",
        });
        return null;
      }
      if (query.length > 250) {
        this.$validator.errors.add({
          field: "ClientName",
          msg: "The Client Name field should be maximum 250 character length",
        });
        return;
      }
      if (this.ClientNames == null || this.ClientNames.length == 0) {
        return null;
      }
      return this.ClientNames.filter((name) => {
        return name.toLowerCase().includes(query.toLowerCase());
      });
    },
    onItemSelected(item) {
      this.ClientName = item;
    },
    CalCulate() {
      this.Quantity = 0.0;
      this.UnitPrice = 0;
      this.ExchangeRate = 0.0;
      var vm = this;
      if (this.CurrencyId && this.Amount && this.Amount > 0 && this.Commodity) {
        if (this.BankCommodities && this.BankCommodities.length > 0) {
          var _ShortName = null;
          var USDPrice = 0;
          for (var i = 0; i < this.Currency.length; i++) {
            if (this.Currency[i].Id == vm.CurrencyId) {
              _ShortName = this.Currency[i].ShortName;
              break;
            }
          }
          for (var n = 0; n < this.BankCommodities.length; n++) {
            if (this.BankCommodities[n].Id == this.Commodity) {
              vm.UnitPrice = this.BankCommodities[n][_ShortName];
              USDPrice = this.BankCommodities[n]["USD"];
            }
          }
          this.Quantity = this.Amount / vm.UnitPrice;
          var ExchangeRate = 0;
          if (_ShortName == "EUR" || _ShortName == "GBP") {
            ExchangeRate = USDPrice / vm.UnitPrice;
          } else {
            ExchangeRate = vm.UnitPrice / USDPrice;
          }
          if (ExchangeRate) {
            this.ExchangeRate = ExchangeRate.toFixed(4);
          }
        }
      }
    },
    SelectDepartment() {
      var data = [...this.Departments];
      if (data.length > 1) {
        var SortedArray = this.Sort(data, "Priority", "asc");
        this.DeptId = SortedArray[0].Id;
        this.FajrReferenceNo = SortedArray[0].RefNo;
      } else if (data.length == 1) {
        this.DeptId = this.Departments[0].Id;
        this.FajrReferenceNo = this.Departments[0].RefNo;
      }
    },
    GetData() {
      var Url = "?id=" + (this.RequestId == null ? 0 : this.RequestId);
      var vm = this;
      this.$store
        .dispatch(ACTIONS.BUY_REQUEST_GET, Url)
        .then((res) => {
          var { data } = res;
          if (data && data.StatusCode == 200) {
            var { buyRequest } = data.ResponseData;
            if (vm.RequestId > 0) {
              vm.DeptId = buyRequest.DeptId;
              vm.ApplicationDate = vm.setFormDate(buyRequest.ApplicationDate);
              vm.ClientName = buyRequest.ClientName;
              vm.CurrencyId = buyRequest.Currency;
              vm.Commodity = buyRequest.Commodityid;
              //vm.DeptId = buyRequest.RequestType;
              vm.FajrReferenceId = buyRequest.RequestId;
              vm.YourRefrence =
                buyRequest.BankReference == "N/A"
                  ? ""
                  : buyRequest.BankReference;
              vm.ValueDate = vm.setFormDate(buyRequest.ValueDate);
              vm.MaturityDate =
                buyRequest.MaturityDate == null
                  ? null
                  : vm.setFormDate(buyRequest.MaturityDate);
              //vm.PurchaseComment = buyRequest.PurchaseComment;
              vm.Comments = buyRequest.PurchaseComment;
              vm.TransactionTypeId = buyRequest.TransactionType;

              vm.FajrReferenceNo = buyRequest.RefNo;
              vm.UnitPrice = buyRequest.UnitPrice;
              vm.Amount = buyRequest.Amount;
              vm.Quantity = buyRequest.Quantity;
              vm.SellAccepted = buyRequest.SellAccepted;
              vm.Sell = buyRequest.Sell;
            } else {
              //vm.FajrReferenceNo = buyRequest.RefNo;
              vm.RefNo = buyRequest.RefNo;
              vm.SelectDepartment();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    CloseModal() {
      this.$emit("Close");
    },
  },
  beforeMount() {
    this.ApplicationDate = this.setFormDate();
    this.ValueDate = this.setFormDate();
    this.GetData();
  },
  computed: {
    ...mapGetters({
      PageSize: "PageSize",

      errorMessage: "GETBUYREQUESTSAVEERROR",
      loading: "GETBUYREQUESTSAVELOADING",

      Departments: "GETREQUESTDEPARTMENTS",
      Currency: "GETCURRENCY",
      BankCommodities: "GETBUYREQUESTBANKCOMMODITIES",
      ClientNames: "GETCLIENTNAMES",
      TRANSACTIONTYPE: "GETTRANSACTIONTYPE",
      CONFIRMLOADING: "GETCONFIRMATIONLOADING",
      CONFIRMERROR: "GETCONFIRMATIONERROR",
      RoleId: "RoleId",
    }),
    ...mapFields({
      ApplicationDateFlags: "ApplicationDate",
      // RequestTypeFlags: "RequestType",
      ClientNameFlags: "ClientName",
      CurrencyFlags: "Currency",
      CommodityidFlags: "Commodityid",
      AmountFlags: "Amount",
      ValueDateFlags: "ValueDate",
      MaturityDateFlags: "MaturityDate",
      UnitPriceFlags: "UnitPrice",
      TransactionTypeFlags: "TransactionType",
      DeptIdFlags: "DeptId",
      BankReferenceFlags: "BankReference",
      PurchaseCommentFlags: "PurchaseComment",

      // UsernameFlags: "Username",
      // PasswordFlags: "Passowrd",
      // ConfirmPasswordFlags: "ConfirmPassword",
      // RolesFlags: "Roles",
      // DepartmentIdFlags: "DepartmentId"
    }),
    CommoditiesOfBank() {
      if (this.BankCommodities && this.BankCommodities.length > 0) {
        if (this.DeptId != 3 || this.DeptId != 4) {
          return this.BankCommodities;
        }
        var data = [...this.BankCommodities];
        var _d = [];
        this.BankCommodities.map(function (val) {
          if (val.ISINTERNATIONAL) {
            _d.push(val);
          }
        });
        return _d;
      }
    },
  },
  watch: {
    Commodity: function (val) {
      this.CalCulate();
    },
    CurrencyId: function (val) {
      this.CalCulate();
    },
    Amount: function () {
      this.CalCulate();
    },
  },
};
</script>

<style >
.v-suggestions {
  position: relative;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.v-suggestions .suggestions {
  position: absolute;
  left: 0;
  top: 36px;
  width: 100%;
  z-index: 100;
  background: #ffffff;
}

.v-suggestions .items {
  list-style: none;
  border: 1px solid #eee;
  margin: 0;
  padding: 0;
  border-width: 0 1px 1px 1px;
}

.v-suggestions .item {
  border-bottom: 1px solid #eee;
  padding: 0.4rem;
}

.v-suggestions .items .item.is-active,
.v-suggestions .items .item:hover {
  background: #eee;
  cursor: pointer;
}

.v-suggestions-input {
  -webkit-appearance: none;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 3px;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16),
    0 0 0 1px rgba(0, 0, 0, 0.08);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  font-size: 1rem;
  height: 2.25em;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.375em - 1px);
  padding-left: calc(0.625em - 1px);
  padding-right: calc(0.625em - 1px);
  padding-top: calc(0.375em - 1px);
  position: relative;
  vertical-align: top;
  background-color: white;
  border-color: #dbdbdb;
  color: #363636;
  max-width: 100%;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  position: relative;
}

.v-suggestions-input:focus,
.v-suggestions-input:active {
  -webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.16),
    0 0 0 1px rgba(0, 0, 0, 0.08);
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.08);
  outline: none;
}
</style>